import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppNotificationUtilClass, MachineMaintenanceDataService } from '@monorepo/services';
import { Injectable } from '@angular/core';
import * as AttachmentActions from './attachment.actions';
import { TAttachmentActionTypes } from './attachment.model';
import { catchError, finalize, from, map, of, switchMap, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AttachmentEffects {
  constructor(
    private actions$: Actions,
    private mmDataService: MachineMaintenanceDataService,
    private appNotificationUtilClass: AppNotificationUtilClass,
  ) {}

  fetchAttachmentList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TAttachmentActionTypes.FetchAttachmentList),
      switchMap((action: AttachmentActions.FetchAttachmentList) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action] as const),
        ),
      ),
      switchMap(([loaderEl, action]) =>
        this.mmDataService.fetchAttachmentList(action.payload).pipe(
          map((res) => new AttachmentActions.FetchAttachmentListSuccess(res)),
          catchError(() => of(new AttachmentActions.FetchAttachmentListFailure())),
          finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
        ),
      ),
    ),
  );

  fetchAttachmentApprovalList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TAttachmentActionTypes.FetchAttachmentApprovalList),
      switchMap((action: AttachmentActions.FetchAttachmentApprovalList) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action] as const),
        ),
      ),
      switchMap(([loaderEl, action]) =>
        this.mmDataService.fetchAttachmentApprovalList(action.payload).pipe(
          map((res) => new AttachmentActions.FetchAttachmentApprovalListSuccess(res)),
          catchError(() => of(new AttachmentActions.FetchAttachmentApprovalListFailure())),
          finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
        ),
      ),
    ),
  );
}
